import { AdminInput, Button, Div, Modal, PropsModal } from '@vgrubs/components';
import { AddModifierGroupComponent } from './ModifierGroupComponents';
import { Dispatch, SetStateAction, useState } from 'react';
import {
  MenuV2Response,
  ModifierGroupItemV2Response,
} from 'components/src/types/menu.types';

export const AddModifierGroupModal = ({
  addModifierGroupModal,
  closeModal,
  setModifierGroups,
  modifierGroups,
  menu,
  setAddNewModifierGroupModal,
}: PropsModal & {
  addModifierGroupModal: boolean;
  setModifierGroups: Dispatch<SetStateAction<ModifierGroupItemV2Response[]>>;
  modifierGroups: ModifierGroupItemV2Response[];
  menu: MenuV2Response | null;
  setAddNewModifierGroupModal: Dispatch<SetStateAction<boolean>>;
}) => {
  const [search, setSearch] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const filteredItems = menu?.modifierGroups?.filter((m) =>
    m.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Modal
      isOpen={addModifierGroupModal}
      closeModal={closeModal}
      header="Add/Edit Modifier Groups"
      logo={false}
      zIndex={100}
      footer={
        <>
          {' '}
          <Button
            $selected
            $w="100%"
            $mb="16"
            $mt="32"
            onClick={() => closeModal?.()}
          >
            Confirm
          </Button>
          <Button
            $selected
            $gray
            $w="100%"
            onClick={() => setAddNewModifierGroupModal(true)}
          >
            Add New Modifier Group
          </Button>
        </>
      }
    >
      <div>
        <Div $mb="20">
          <AdminInput
            placeholder="Search Modifier Group"
            search
            value={search}
            onChange={handleInputChange}
          />
        </Div>
        {filteredItems?.map((item, i) => (
          <AddModifierGroupComponent
            item={item}
            key={i}
            modifierGroups={modifierGroups}
            setModifierGroups={setModifierGroups}
          />
        ))}
      </div>
    </Modal>
  );
};
